module.exports = __webpack_public_path__ + "img/armhole length back.53e33dbd.png";